import { render, staticRenderFns } from "./messageManagementList.vue?vue&type=template&id=55060975&"
import script from "./messageManagementList.vue?vue&type=script&lang=js&"
export * from "./messageManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports